import React, { useEffect, useState } from "react";
import { TextField, IconButton, MenuItem, Grid } from "@mui/material";
import {
  SwapHoriz,
  AddCircleOutline,
  RemoveCircleOutline,
} from "@mui/icons-material";
import {
  Card,
  CardBody,
  CardText,

  // Table,
} from "reactstrap";
import Nav from "../NavBar/Nav";
import FooterNew from "../NavBar/FooterNew";
import { Col, Row, Button } from "reactstrap";
import { Carousel } from "react-bootstrap";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useForm, Controller } from "react-hook-form";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import GoogleInput from "./GoogleInput";
import axios from "axios";
import base_url from "../../api/bootapi";
import { Player } from "video-react";
import "video-react/dist/video-react.css";

import Swal from "sweetalert2";
import GoogleAddressInput from "./GoogleAddressInput";
import { useDisclosure } from "@mantine/hooks";
import { Modal } from "@mantine/core";
import GoogleInputAdditonal from "./GoogleInputAdditonal";
const BookVehicleForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    control,
  } = useForm();
  const location = useLocation();

  const [backdropopen, setbackdropopen] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const [mobile, setMobile] = useState();
  const [totalPassenger, setTotalPassenger] = useState(null);
  const [vehicleLocation, setVehicleLocation] = useState();
  const [totalDistance, setTotalDistance] = useState();
  const [address, SetAddress] = useState(null);
  const [vehicleOption, setVehicleOption] = useState([]);
  const [selectedVehicleOption, setSelectedVehicleOption] = useState();

  const [selectedVehicleType, setSelectedVehicleType] = useState();
  const [vehicleData, setVehicleData] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [amenitiesList, setAmenitiesList] = useState([]);

  const [tripStart, setTripStart] = useState(null);
  const [tripEnd, setTripEnd] = useState(null);
  const [tripStartDate, setTripStartDate] = useState(null);
  const [tripEndDate, setTripEndDate] = useState(null);
  const [stages, setStages] = useState([
    { from: null, to: null, fromDate: null, toDate: null, distance: null },
  ]);

  const [opened, { open, close }] = useDisclosure(false);
  const [additionalPointIndex, setAdditionalPointIndex] = useState(null);

  const [additionalPoint, setAdditionalPoint] = useState("");

  const [tripDetails, setTripDetails] = useState([
    {
      from_loc: null,
      to_loc: null,
      departure: null,
      arrival: null,
      additional_points: [],
      isNextStartPoint: false,
      distance: 0,
      of_stops: 0,
    },
  ]);

  useEffect(() => {
    const total = tripDetails.reduce(
      (sum, item) => sum + (item.distance || 0),
      0
    );

    setTotalDistance(Number(total.toFixed(2)));

    const trip_start_date = tripDetails[0]["departure"];
    const trip_end_date = tripDetails[tripDetails.length - 1]["departure"];

    const trip_start_point = tripDetails[0]["from_loc"];
    const trip_end_point = tripDetails[tripDetails.length - 1]["to_loc"];

    console.log(trip_start_date, trip_end_date);

    if (trip_start_date) {
      setTripStartDate(trip_start_date);
    }
    if (trip_end_date) {
      setTripEndDate(trip_end_date);
    }

    if (trip_start_point) {
      setTripStart(trip_start_point);
    }

    if (trip_end_point) {
      setTripEnd(trip_end_point);
    }
  }, [tripDetails]);

  const [totalDays, setTotalDays] = useState(0);
  useEffect(() => {
    if (tripStartDate && tripEndDate) {
      const startDate = new Date(tripStartDate);
      const endDate = new Date(tripEndDate);

      const diffInMs = endDate - startDate;
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      // Always include the first day
      const total = Number(diffInDays.toFixed(0)) + 1;

      // Prevent negative days (if end < start)
      setTotalDays(total > 0 ? total : 0);
    }
  }, [tripStartDate, tripEndDate]);
  const [baseimage, setbaseimage] = useState([]);

  const isImage = (url) => {
    const imageExtensions = [".jpeg", ".jpg", ".png", ".gif", ".bmp"];
    const fileExtension = url.substring(url.lastIndexOf(".")).toLowerCase();
    return imageExtensions.includes(fileExtension);
  };

  useEffect(() => {
    getVehicleOption();
    getAllAmenities();
  }, []);

  const getAllAmenities = () => {
    setbackdropopen(true);
    axios.get(`${base_url.api1}/tourapp/amenities`).then(
      (response) => {
        setAmenitiesList(response.data.Amenities);

        setbackdropopen(false);
      },
      (error) => {
        let errorResp = JSON.stringify(error.response.status);

        setAmenitiesList([]);
        setbackdropopen(false);
        //console.log(JSON.stringify(error));
      }
    );
  };

  // useEffect(() => {
  //   if (stages.length > 0) {
  //     const firstStage = stages[0];
  //     const lastStage = stages[stages.length - 1];

  //     // Set the first stage's 'from' and 'fromDate' to tripStart and tripStartDate if they are not null or undefined
  //     if (firstStage.from) {
  //       setTripStart(firstStage.from);
  //     }
  //     if (firstStage.fromDate) {
  //       setTripStartDate(firstStage.fromDate);
  //     }

  //     // Set the last stage's 'to' and 'toDate' to tripEnd and tripEndDate if they are not null or undefined
  //     if (lastStage.to) {
  //       setTripEnd(lastStage.to);
  //     }
  //     if (lastStage.toDate) {
  //       setTripEndDate(lastStage.toDate);
  //     }
  //   }
  // }, [stages]);

  const getAmenityTitle = (keyValue) => {
    const amenity = amenitiesList.find(
      (amenity) => amenity.key_value === keyValue
    );
    return amenity ? amenity.title : null;
  };

  const getVehicleOption = (vehicleType) => {
    setSelectedVehicleType(vehicleType);
    setbackdropopen(true);
    if (vehicleType) {
      axios
        .get(
          `${base_url.api1}/tourapp/vehicle_dropdown?status=True&vehicle=` +
            vehicleType
        )
        .then((response) => {
          let vehicleDetails = response.data.Vehicle;
          //console.log("vehicle--->", vehicleDetails);
          setVehicleOption(vehicleDetails);

          setbackdropopen(false);
        })
        .catch((error) => {
          //console.log("Error");
          setVehicleOption([]);
          setbackdropopen(false);
        });
    }
    setbackdropopen(false);
  };

  function addDaysToDate(dateString, daysToAdd = 1) {
    const date = new Date(dateString);
    const newDate = new Date(date.getTime() + daysToAdd * 24 * 60 * 60 * 1000);

    const pad = (n) => String(n).padStart(2, "0");

    return `${newDate.getFullYear()}-${pad(newDate.getMonth() + 1)}-${pad(
      newDate.getDate()
    )}T${pad(newDate.getHours())}:${pad(newDate.getMinutes())}`;
  }
  const handleAddTripDetails = () => {
    const prev_start_point = tripDetails[tripDetails.length - 1]["to_loc"];
    const prev_start_date = tripDetails[tripDetails.length - 1]["departure"];
    let next_start_Date = null;
    if (prev_start_date) {
      next_start_Date = addDaysToDate(prev_start_date);
    }
    setTripDetails([
      ...tripDetails,
      {
        from_loc: prev_start_point,
        to_loc: null,
        departure: next_start_Date,
        arrival: null,
        additional_points: [],
        isNextStartPoint: true,
        distance: 0,
        of_stops: 0,
      },
    ]);
  };

  const handleRemoveTripDetails = (index) => {
    if (tripDetails.length > 1) {
      const newTripDetails = tripDetails.filter((_, i) => i !== index);
      setTripDetails(newTripDetails);
    }
  };
  const [carouselIndex, setCarouselIndex] = useState(0);

  const handleSelectCarousel = (selectedIndex, e) => {
    if (e && e.source === "select") return; // Prevent default behavior
    setCarouselIndex(selectedIndex);
  };

  const getVehicleDetails = (id) => {
    setbackdropopen(true);
    axios
      .get(`${base_url.api1}/tourapp/vehicle_get?id=` + id)
      .then((response) => {
        let vehicleDetails = response.data.vehicle;
        //console.log("vehicleLocation-->", vehicleDetails.station_of_vehicle);
        setVehicleLocation(vehicleDetails.station_of_vehicle);
        setVehicleData({
          availability: vehicleDetails.availability,
          color: vehicleDetails.color,
          created_date: vehicleDetails.created_date,
          id: vehicleDetails.id,
          number_of_seat: vehicleDetails.number_of_seat,
          cost_per_day: vehicleDetails.cost_per_day,
          cost_per_km: vehicleDetails.cost_per_km,
          distance_per_day: vehicleDetails.distance_per_day,
          type_of_vehicle: vehicleDetails.type_of_vehicle,
          updated_date: vehicleDetails.updated_date,
          vehicle_facility: vehicleDetails.vehicle_facility,
          vehicle_model: vehicleDetails.vehicle_model,
          vehicle_no: vehicleDetails.vehicle_no,
          station_of_vehicle: vehicleDetails.station_of_vehicle,
          manufactured_year: vehicleDetails.manufactured_year,
        });
        setSelectedAmenities(vehicleDetails.amenities);
        setbaseimage(vehicleDetails.images);

        setbackdropopen(false);
      })
      .catch((error) => {
        //console.log("Error");
        setbackdropopen(false);
      });
  };

  const handleMobileInputChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (value.length > 10) {
      return;
    }
    setMobile(value);
    setValue("contact", value, { shouldValidate: true });
  };
  const handlePassengerInputChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");

    setTotalPassenger(value);
  };

  const handleVehicleChange = (e) => {
    console.log("vehicle", e.target.value);
    if (e.target.value !== "") {
      getVehicleDetails(e.target.value);
    }
    setSelectedVehicleOption(e.target.value);
  };

  const handleAddStage = () => {
    setStages([
      ...stages,
      { from: null, to: null, fromDate: null, toDate: null, distance: null },
    ]);
  };

  const handleRemoveStage = (index) => {
    if (stages.length > 1) {
      const newStages = stages.filter((_, i) => i !== index);
      setStages(newStages);
    }
  };
  const handleInputChange = (index, field, value) => {
    //console.log("field", field);
    const newStages = [...stages];
    newStages[index][field] = value;
    setStages(newStages);
  };

  const handleTripDetailsInputChange = (index, field, value) => {
    const newTripDetails = [...tripDetails];
    newTripDetails[index][field] = value;
    setTripDetails(newTripDetails);

    if (field === "from_loc" || field === "to_loc") updateOfStops(index);
  };

  const handleSwap = (index) => {
    //console.log("stages", stages);
    const newStages = [...stages];
    [newStages[index].from, newStages[index].to] = [
      newStages[index].to,
      newStages[index].from,
    ];
    setStages(newStages);
  };

  const getDistance = async (origin, destination) => {
    try {
      const response = await axios.post(`${base_url.api1}/tourapp/distance`, {
        origins: origin,
        destinations: destination,
      });

      const distanceValue = response.data.data.distance.value;

      const kmDistance = distanceValue / 1000; // Convert to kilometers

      return kmDistance;
    } catch (error) {
      console.error(
        `Error fetching distance from ${origin} to ${destination}`,
        error
      );
      return 0; // Return false to indicate error
    }
  };
  const handleCalculate = async () => {
    console.log("first");
    const from_loc = tripDetails[additionalPointIndex]["from_loc"];
    const additional_points =
      tripDetails[additionalPointIndex]["additional_points"];
    const to_loc = tripDetails[additionalPointIndex]["to_loc"];
    let totalDistance = 0;

    // if (!from_loc || !to_loc) return;

    let points = [from_loc];

    if (Array.isArray(additional_points) && additional_points.length > 0) {
      points = points.concat(additional_points.map((p) => p.additional_point));
    }

    points.push(to_loc);

    for (let i = 0; i < points.length - 1; i++) {
      const dist = await getDistance(points[i], points[i + 1]);
      totalDistance += dist;
    }

    console.log("Total Distance:", totalDistance.toFixed(2), "km");

    const updatedTrips = [...tripDetails];
    updatedTrips[additionalPointIndex].distance = Number(
      totalDistance.toFixed(2)
    );
    setTripDetails(updatedTrips);
  };

  const handleAddAdditoinalPoint = async () => {
    console.log(additionalPointIndex);

    if (!additionalPoint.trim()) {
      return;
    }

    const updatedTrips = [...tripDetails];
    const trip = { ...updatedTrips[additionalPointIndex] };

    trip.additional_points = [
      ...(trip.additional_points || []),
      { additional_point: additionalPoint.trim() },
    ];

    trip.of_stops = trip.of_stops + 1;

    updatedTrips[additionalPointIndex] = trip;
    setTripDetails(updatedTrips);
    setAdditionalPoint("");
  };

  const handleDeleteAdditionalPoint = (tripIndex, pointIndex) => {
    const updatedTrips = [...tripDetails];
    const currentTrip = { ...updatedTrips[tripIndex] };

    currentTrip.additional_points = currentTrip.additional_points.filter(
      (_, idx) => idx !== pointIndex
    );

    currentTrip.of_stops = currentTrip.of_stops - 1;

    updatedTrips[tripIndex] = currentTrip;
    setTripDetails(updatedTrips);
  };

  const handleClose = async () => {
    close();

    setAdditionalPoint("");
    await handleCalculate();
    // updateStopsCount();
  };

  const updateOfStops = (index) => {
    const updatedTrips = [...tripDetails];
    const trip = { ...updatedTrips[index] };

    const countFrom = trip.from_loc ? 1 : 0;
    const countTo = trip.to_loc ? 1 : 0;
    const countAdditional = trip.additional_points?.length || 0;

    trip.of_stops = countFrom + countAdditional + countTo;

    updatedTrips[index] = trip;
    setTripDetails(updatedTrips);
  };

  const calculateTotalDistance = async (stages) => {
    let totalDistance = 0;
    const updatedStages = [...stages];

    try {
      // First stage: Vehicle location to first 'from' location
      if (stages[0].from) {
        const distanceToFirstFrom = await getDistance(
          vehicleLocation,
          stages[0].from,
          0,
          "departure"
        );
        if (distanceToFirstFrom === false) {
          throw new Error(
            `Error calculating distance for 'departure' of first stage`
          );
        }
        totalDistance += distanceToFirstFrom;
      }

      // Iterate through each stage
      for (let i = 0; i < stages.length; i++) {
        const stage = stages[i];

        // Calculate distance from 'from' location to 'to' location
        if (stage.from && stage.to) {
          const distanceFromTo = await getDistance(
            stage.from,
            stage.to,
            i,
            "arrival"
          );
          if (distanceFromTo === false) {
            throw new Error(
              `Error calculating distance from '${stage.from}' to '${
                stage.to
              }' in 'arrival' of stage ${i + 1}`
            );
          }
          totalDistance += distanceFromTo;
          updatedStages[i].distance = distanceFromTo.toFixed(2);
          setStages(updatedStages);
        }

        // If not the last stage, calculate distance from current 'to' location to next 'from' location
        if (i < stages.length - 1 && stages[i].to && stages[i + 1].from) {
          const distanceToNextFrom = await getDistance(
            stages[i].to,
            stages[i + 1].from,
            i + 1,
            "departure"
          );
          if (distanceToNextFrom === false) {
            throw new Error(
              `Error calculating distance from '${stages[i].to}' to '${
                stages[i + 1].from
              }' in 'departure' between stage ${i + 1} and ${i + 2}`
            );
          }
          totalDistance += distanceToNextFrom;
        }
      }

      // Last stage: Last 'to' location to vehicle location
      const lastStage = stages[stages.length - 1];
      if (lastStage.to) {
        const finalDistance = await getDistance(
          lastStage.to,
          vehicleLocation,
          stages.length - 1,
          "arrival"
        );
        if (finalDistance === false) {
          throw new Error(
            `Error calculating final distance to '${vehicleLocation}'`
          );
        }
        totalDistance += finalDistance;
      }

      return totalDistance; // Return total distance calculated successfully
    } catch (error) {
      console.error("Error calculating total distance:", error);

      // Determine whether the error occurred in 'departure' or 'arrival'
      let errorMessage = "";
      let stageInfo = "";

      if (error.message.includes("'departure'")) {
        errorMessage = "Error in departure stage";
        stageInfo = error.message.match(/stage (\d+)/);
      } else if (error.message.includes("'arrival'")) {
        errorMessage = "Error in arrival stage";
        stageInfo = error.message.match(/stage (\d+)/);
      }

      const stageIndex = stageInfo ? stageInfo[1] : "";

      // Show SweetAlert with error message and stage details
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
        footer: `${errorMessage} in stage ${stageIndex}`,
      });

      throw error; // Throw the error to handle in calling function
    }
  };

  const onSubmit = async (data) => {
    setbackdropopen(true);
    // let totalDistance = 0;
    // try {
    //   totalDistance = await calculateTotalDistance(stages);

    //   if (totalDistance !== false) {
    //     totalDistance = totalDistance.toFixed(2);

    //     //console.log("Total distance:", totalDistance);
    //   } else {
    //     console.error("Failed to calculate total distance");
    //     setbackdropopen(false);
    //     return;
    //   }
    // } catch (error) {
    //   console.error("Error in handleSubmit:", error);
    //   setbackdropopen(false);
    //   return;
    // }

    const requestTripDetails = tripDetails.map((tripDetail) => ({
      from_loc: tripDetail.from_loc,
      to_loc: tripDetail.to_loc,
      departure: tripDetail.departure,
      arrival: null,
      distance: Number(tripDetail.distance.toFixed(2)),
      of_stops: tripDetail.of_stops,
      additional_points: tripDetail.additional_points,
    }));

    // const itineraryDetails = stages.map((stage) => ({
    //   from_loc: stage.from,
    //   to_loc: stage.to,
    //   departure: stage.fromDate,
    //   arrival: stage.toDate,
    //   distance: stage.distance,
    // }));

    //console.log("itinerary", itineraryDetails);

    const data1 = {
      name: data.first_name,
      last_name: data.last_name,
      group_name: data.group_name || null,
      phone_number: mobile,
      email_id: data.email,
      number_of_people: null,
      tour_type: null,
      additional_info: data.note || null,
      status: "pending",
      vehicle_id: selectedVehicleOption,
      itinerary: requestTripDetails,
      distance: totalDistance,
      address: address,
      from_loc: tripStart,
      to_loc: tripEnd,
      total_days: totalDays,
      departure: tripStartDate,
      arrival: tripEndDate,
    };

    //console.log("data", data1);

    axios.post(`${base_url.api1}/tourapp/vehicle_booking_request`, data1).then(
      (response) => {
        //console.log(response);
        if (response.status === 200) {
          setbackdropopen(false);

          Swal.fire({
            icon: "info",
            title: "Booking Request Received",
            html: `
            <div style="text-align: center;">
              <h3>Booking ID: ${mobile}</h3>
              <p>Total Distance: ${totalDistance} KM</p>
            </div>
          `,
            confirmButtonText: "OK",
          }).then(() => {
            navigate("/thank-you-page", {
              state: { isClaimed: 2 },
            });
          });

          // Swal.fire({
          //   icon: "info",
          //   title: "Booking Request Received",
          //   text: "Your booking request has been received successfully",
          //   confirmButtonText: "OK",
          // }).then(() => {
          //   navigate({
          //     pathname: "/thank-you-page",
          //     state: { isClaimed: 2 },
          //   });
          // });

          document.getElementById("myForm").reset();
        } else {
          setbackdropopen(false);
        }
      },
      (error) => {
        Swal.fire({
          icon: "error",
          title: "Network Error",
          text: "There was a problem connecting to the server. Please try again later.",
        });

        document.getElementById("myForm").reset();
        setbackdropopen(false);
      }
    );
  };

  return (
    <div style={{ backgroundColor: "#F5F6FA" }}>
      <React.Fragment>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropopen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Nav />

        <Modal
          opened={opened}
          onClose={handleClose}
          title="Additional Point"
          withCloseButton={false}
          // styles={{
          //   content: {
          //     height: "80vh", // or any other value like '400px'
          //     overflowY: "auto", // to make it scrollable
          //   },
          // }}
          size={"md"}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "70vh",
              gap: "15px",
            }}
          >
            <div className="modal-additional-input-wrapper">
              <GoogleInputAdditonal
                tripDetails={tripDetails}
                index={additionalPointIndex}
                additionalPoint={additionalPoint}
                setAdditionalPoint={setAdditionalPoint}
              />

              <Button
                color="primary"
                onClick={handleAddAdditoinalPoint}
                style={{
                  marginLeft: "10px",
                  padding: "5px 20px",
                  width: "fit-content",
                }}
              >
                Add
              </Button>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                flex: 1,
                overflow: "auto",
              }}
            >
              {tripDetails[additionalPointIndex] &&
                tripDetails[additionalPointIndex]?.additional_points?.length >
                  0 &&
                tripDetails[additionalPointIndex].additional_points.map(
                  (point, index) => {
                    return (
                      <div className="additonal-item-wrapper" key={index}>
                        <span>{point.additional_point}</span>
                        <div
                          style={{
                            backgroundColor: "none",
                            color: "red",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleDeleteAdditionalPoint(
                              additionalPointIndex,
                              index
                            )
                          }
                        >
                          <RemoveCircleOutline />
                        </div>
                      </div>
                    );
                  }
                )}

              {!tripDetails[additionalPointIndex] ||
                (tripDetails[additionalPointIndex]?.additional_points.length ===
                  0 && (
                  <span className="modal-empty-additional">
                    No Additional Points
                  </span>
                ))}
            </div>

            <Button
              color="secondary"
              style={{
                width: "fit-content",
                marginTop: "auto",
                float: "right",
                marginLeft: "auto",
                padding: "10px 25px",
              }}
              onClick={handleClose}
            >
              Done
            </Button>
          </div>
        </Modal>

        <div className="container">
          <div
            class="page-head d-flex justify-content-between p-4"
            style={{ marginTop: "1.3rem" }}
          >
            <ul class="breadcrums">
              <Link to="/" class="b-link">
                Home
              </Link>
              <span className="s_span ">&raquo;</span>
              <Link to="#" class="b-link">
                Linsoa VIP transportation
              </Link>
              <span className="s_span ">&raquo;</span>
              <Link to="#" class="b-link active">
                Make a Booking
              </Link>
            </ul>
          </div>
          <Row className="px-0">
            <Col lg={12} className="carosol_img">
              <form
                id="myForm"
                onSubmit={handleSubmit(onSubmit)}
                className="login_container new-itienerary"
              >
                <p className="tour_head_text_3">Personal Details</p>
                <hr style={{ width: "20%" }} />
                <div className="row">
                  <div className="col-md-4">
                    <label>
                      Last Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        className="form-control"
                        placeholder="Last Name"
                        type="text"
                        {...register("last_name", {
                          required: true,
                        })}
                      />
                      <i className="fa fa-user-o designi" />
                    </div>
                    {errors.last_name && (
                      <p className="errormessage">Last Name is Required</p>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label>
                      First Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        className="form-control"
                        placeholder="First Name"
                        type="text"
                        {...register("first_name", {
                          required: true,
                        })}
                      />
                      <i className="fa fa-user-o designi" />
                    </div>
                    {errors.first_name && (
                      <p className="errormessage">First Name is Required</p>
                    )}
                  </div>

                  <div className="col-md-4">
                    <label>Group Name</label>
                    <div style={{ position: "relative" }}>
                      <input
                        className="form-control"
                        placeholder="Group Name"
                        type="text"
                        {...register("group_name", {
                          required: false,
                        })}
                      />
                      <i className="fa fa-users designi" />
                    </div>
                  </div>

                  <Col md={4}>
                    <label>Address:</label>
                    <GoogleAddressInput
                      googleAddress={address}
                      setGoogleAddress={SetAddress}
                    />
                  </Col>

                  <Col md={4}>
                    <label>
                      Mobile Number<span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        value={mobile}
                        className="form-control"
                        placeholder="Mobile Number"
                        type="text"
                        {...register("contact", {
                          required: "Mobile Number is required",
                          validate: (value) =>
                            value.length === 10 ||
                            "Mobile Number must be 10 digits",
                        })}
                        onChange={handleMobileInputChange} // Move onChange handler here
                      />
                      <i className="fa fa-phone designi" />
                    </div>
                    {errors.contact && (
                      <p className="errormessage">{errors.contact.message}</p>
                    )}
                  </Col>
                  <div className="col-md-4">
                    <label>
                      Email Address<span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        className="form-control"
                        placeholder="Email Address"
                        type="email"
                        {...register("email", {
                          required: "Email Address is Required",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Invalid email address",
                          },
                        })}
                      />
                      <i className="fa fa-envelope designi" />
                    </div>
                    {errors.email && (
                      <p className="errormessage">{errors.email.message}</p>
                    )}
                  </div>
                  {/* <div className="col-md-4">
                    <label htmlFor="vehicle-select">Select Vehicle:</label>
                    <div>
                      <select
                        id="note"
                        onChange={handleVehicleChange}
                        className="form-control"
                        required
                      >
                        <option value="">Select a vehicle</option>
                        {vehicleOption?.map((vehicle) => (
                          <option key={vehicle.id} value={vehicle.id}>
                            {`${vehicle.vehicle_model} (${vehicle.type_of_vehicle})`}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div> */}
                  {/* <Col md={4}>
                    <label>Number of passengers</label>
                    <div style={{ position: "relative" }}>
                      <input
                        value={totalPassenger}
                        className="form-control"
                        placeholder="Number of passengers"
                        type="text"
                        onChange={handlePassengerInputChange} // Move onChange handler here
                      />

                      <i className="fa fa-users designi" />
                    </div>
                  </Col>
                  <div className="col-md-4">
                    <label>Type of Trip</label>
                    <div style={{ position: "relative" }}>
                      <select
                        className="form-control"
                        {...register("tripType", {
                          required: false,
                        })}
                      >
                        <option value="">Select</option>
                        <option value="Tourist Trip">Tourist Trip</option>
                        <option value="Sport Event">Sport Event</option>
                        <option value="Business Trip">Business Trip</option>
                        <option value="School Trip">School Trip</option>
                        <option value="Airport Transfer">
                          Airport Transfer
                        </option>
                        <option value="Wedding">Wedding</option>
                      </select>
                      <i className="fa fa-suitcase designi" />
                    </div>
                  </div> */}
                </div>
                <div className="row">
                  <p className="tour_head_text_3" style={{ marginTop: "30px" }}>
                    Trip Details
                  </p>
                  <hr style={{ width: "20%" }} />
                  {tripDetails.map((tripDetail, index) => (
                    <div
                      className="mb-4"
                      style={{ paddingLeft: "0px" }}
                      key={index}
                    >
                      <div className="row ">
                        <div className="col-md-3">
                          <div className="d-flex justiy-content-start">
                            <div
                              style={{ position: "relative", width: "100%" }}
                            >
                              <label>
                                Start Date and Time
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="datetime-local"
                                className="form-control"
                                value={tripDetail.departure}
                                onChange={(e) =>
                                  handleTripDetailsInputChange(
                                    index,
                                    "departure",
                                    e.target.value
                                  )
                                }
                                required
                              />
                              <i
                                className="fa fa-clock-o designi"
                                style={{ top: "34px", left: "10px" }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <label>
                            Start point
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <GoogleInput
                            setValue={(value) =>
                              handleTripDetailsInputChange(
                                index,
                                "from_loc",
                                value
                              )
                            }
                            currValue={tripDetail.from_loc}
                            setStages={setTripDetails}
                            stages={tripDetails}
                            index={index}
                            field="from_loc"
                          />
                        </div>

                        <div className="col-md-3">
                          <label>Additional point</label>

                          <div className="addtional-point-wrapper">
                            {tripDetail.additional_points.length > 0 ? (
                              <span
                                className="view-additional-point"
                                onClick={() => {
                                  setAdditionalPointIndex(index);

                                  open();
                                }}
                              >
                                View Additional Point
                              </span>
                            ) : (
                              <span>No Additional Point</span>
                            )}
                            <Button
                              color="primary"
                              onClick={() => {
                                setAdditionalPointIndex(index);

                                open();
                              }}
                              style={{
                                marginLeft: "10px",
                                padding: "5px",
                                width: "fit-content",
                              }}
                            >
                              <AddCircleOutline />
                            </Button>
                          </div>

                          {/* <GoogleInput
                            setValue={(value) =>
                              handleTripDetailsInputChange(
                                index,
                                "additional_point",
                                value
                              )
                            }
                            currValue={tripDetail.additional_point}
                            setStages={setTripDetails}
                            stages={tripDetails}
                            index={index}
                            field="additional_point"
                          /> */}
                        </div>

                        <div className="col-md-3">
                          <div className="d-flex justiy-content-start">
                            <div
                              style={{ position: "relative", width: "100%" }}
                            >
                              <label>
                                Finish point
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <GoogleInput
                                setValue={(value) =>
                                  handleTripDetailsInputChange(
                                    index,
                                    "to_loc",
                                    value
                                  )
                                }
                                currValue={tripDetail.to_loc}
                                setStages={setTripDetails}
                                stages={tripDetails}
                                index={index}
                                field="to_loc"
                              />
                            </div>

                            {tripDetails.length > 1 && index > 0 && (
                              <div className="text-center">
                                <div
                                  onClick={() => handleRemoveTripDetails(index)}
                                  style={{
                                    backgroundColor: "none",
                                    color: "red",
                                    cursor: "pointer",
                                    marginLeft: "20px",
                                    marginTop: "30px",
                                  }}
                                >
                                  <RemoveCircleOutline />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-md-3 blank-form-control">
                          <label># of stops</label>
                          <input
                            className="form-control "
                            disabled
                            value={tripDetail.of_stops}
                          />
                        </div>

                        <div className="col-md-3 blank-form-control">
                          <label>Total kilometers(km)</label>
                          <input
                            disabled
                            className="form-control"
                            value={Number(tripDetail.distance.toFixed(2))}
                          />
                        </div>

                        {/* <div className="col-md-3">
                        <div className="d-flex justiy-content-start">
                          <div style={{ position: "relative" }}>
                            <label>
                              Finish Date and Time
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="datetime-local"
                              className="form-control"
                              {...register("tripEndDate", {
                                required: false,
                              })}
                              required
                            />
                            <i
                              className="fa fa-clock-o designi"
                              style={{ top: "34px", left: "10px" }}
                            />
                          </div>
                        </div>
                      </div> */}
                      </div>
                    </div>
                  ))}

                  <Button
                    color="primary"
                    onClick={handleAddTripDetails}
                    style={{ marginTop: "10px", width: "200px" }}
                  >
                    <AddCircleOutline /> Additional Day
                  </Button>
                </div>

                <div className="row ">
                  <p className="tour_head_text_3" style={{ marginTop: "30px" }}>
                    Trip Summary
                  </p>
                  <hr style={{ width: "20%" }} />
                  <div className="mb-4" style={{ paddingLeft: "0px" }}>
                    <div className="row align-items-center">
                      {/* <div className="col-md-3">
                            <label>
                              Start point
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <GoogleInput
                              placeholder="Enter From Address"
                              setValue={(value) =>
                                handleInputChange(index, "from", value)
                              }
                              currValue={stage.from}
                              setStages={setStages}
                              stages={stages}
                              index={index}
                              field="from"
                            />
                          </div> */}

                      <div className="col-md-3">
                        <div className="d-flex justiy-content-start">
                          <div style={{ position: "relative", width: "100%" }}>
                            <label>Start Date</label>
                            <input
                              type="date"
                              className="form-control"
                              {...register("departure", {
                                required: false,
                              })}
                              value={
                                tripStartDate
                                  ? tripStartDate.split("T")[0]
                                  : null
                              }
                              onChange={(e) => {
                                console.log(e.target.value);
                                setTripStartDate(e.target.value);
                              }}
                              disabled
                            />
                            <i
                              className="fa fa-clock-o designi"
                              style={{ top: "34px", left: "10px" }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3 blank-form-control">
                        <label>Start point</label>
                        <input
                          style={{ paddingLeft: "0px !important" }}
                          className="form-control"
                          {...register("from_loc", {
                            required: false,
                          })}
                          disabled
                          value={tripStart}
                        />
                      </div>

                      <div className="col-md-3">
                        <div className="d-flex justiy-content-start">
                          <div style={{ position: "relative", width: "100%" }}>
                            <label>Finish Date</label>
                            <input
                              type="date"
                              className="form-control"
                              {...register("arrival", {
                                required: false,
                              })}
                              disabled
                              value={
                                tripEndDate ? tripEndDate.split("T")[0] : null
                              }
                              onChange={(e) => {
                                console.log(e.target.value);
                                setTripEndDate(e.target.value);
                              }}
                            />
                            <i
                              className="fa fa-clock-o designi"
                              style={{ top: "34px", left: "10px" }}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3 blank-form-control">
                        <label>Finish point</label>
                        <input
                          style={{ paddingLeft: "0px !important" }}
                          className="form-control"
                          {...register("to_loc", {
                            required: false,
                          })}
                          disabled
                          value={tripEnd}
                        />
                      </div>
                      {/* <div className="col-md-1 text-center">
                            <Button
                              color="primary"
                              onClick={() => handleSwap(index)}
                              style={{
                                width: "65%",
                                backgroundColor: "#1976d2",
                                color: "white",
                                marginTop: "20px",
                                borderRadius: "50%",
                              }}
                            >
                              <SwapHoriz />
                            </Button>
                          </div> */}
                      <div className="col-md-3 blank-form-control">
                        <label>Total Days</label>
                        <input
                          placeholder="Enter Total Days"
                          className="form-control"
                          {...register("total_days", {
                            required: false,
                          })}
                          disabled
                          value={totalDays}
                        />
                      </div>

                      <div className="col-md-3 blank-form-control">
                        <label>Total kilometers(km)</label>
                        <input
                          placeholder="Enter Total km"
                          className="form-control"
                          {...register("distance", {
                            required: false,
                          })}
                          disabled
                          value={totalDistance}
                        />
                      </div>
                      {/* <div className="col-md-2">
                            <div style={{ position: "relative" }}>
                              <label>
                                Departure/Arrival
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <select
                                className="form-control"
                                value={stage.dateType}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "fromDate",
                                    e.target.value
                                  )
                                }
                                required
                              >
                                <option value="Arrival">Arrival</option>
                                <option value="Departure">Departure</option>
                              </select>
                              <i
                                className="fa fa-plane designi"
                                style={{ top: "34px", left: "10px" }}
                              />
                            </div>
                          </div> */}
                      {/* <div className="col-md-3">
                            <div className="d-flex justiy-content-start">
                              <div style={{ position: "relative" }}>
                                <label>
                                  Finish Date and Time
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="datetime-local"
                                  className="form-control"
                                  value={stage.date}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "toDate",
                                      e.target.value
                                    )
                                  }
                                  required
                                />
                                <i
                                  className="fa fa-clock-o designi"
                                  style={{ top: "34px", left: "10px" }}
                                />
                              </div>
                              <div className=" text-center">
                                {stages.length > 1 && (
                                  <div
                                    onClick={() => handleRemoveStage(index)}
                                    style={{
                                      backgroundColor: "none",
                                      color: "red",
                                      cursor: "pointer",
                                      marginLeft: "20px",
                                      marginTop: "30px",
                                    }}
                                  >
                                    <RemoveCircleOutline />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div> */}
                    </div>
                  </div>
                </div>

                <div className="row mr-3">
                  <p className="tour_head_text_3">Booking Details</p>
                  <hr style={{ width: "20%" }} />
                  <div className="row">
                    <div className="col-md-4">
                      <label
                        htmlFor="vehicleType"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Vehicle Type:
                      </label>
                      <select
                        name="type_of_vehicle"
                        className="form-select"
                        value={selectedVehicleType}
                        onChange={(e) => getVehicleOption(e.target.value)}
                      >
                        <option value="doublebus">Double Decker Bus</option>
                        <option value="bus">Bus</option>
                        <option value="sprinter">Sprinter</option>
                        <option value="minivan">MiniVan</option>
                        <option value="car">Car</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="vehicle-select">Select Vehicle:</label>
                      <div>
                        <select
                          id="note"
                          onChange={handleVehicleChange}
                          value={selectedVehicleOption}
                          className="form-select"
                          required
                        >
                          <option value="">Select a vehicle</option>
                          {vehicleOption && vehicleOption.length > 0 ? (
                            vehicleOption.map((vehicle) => (
                              <option key={vehicle.id} value={vehicle.id}>
                                {`${vehicle.vehicle_model}`}
                              </option>
                            ))
                          ) : (
                            <option disabled>No options available</option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {selectedVehicleOption && (
                        <Card>
                          <CardBody>
                            <Row>
                              <Col md={3}>
                                <CardText>
                                  <b>Type of Vehicle:</b>{" "}
                                  {vehicleData.type_of_vehicle}
                                </CardText>
                                <CardText>
                                  <b>Vehicle Model:</b>{" "}
                                  {vehicleData.vehicle_model}
                                </CardText>
                                <CardText>
                                  <b>Manufactured Year:</b>{" "}
                                  {vehicleData.manufactured_year}
                                </CardText>
                                <CardText>
                                  <b>Color:</b> {vehicleData.color}
                                </CardText>
                                <CardText>
                                  <b>Vehicle Number:</b>{" "}
                                  {vehicleData.vehicle_no}
                                </CardText>
                                <CardText>
                                  <b>Number of Seats:</b>{" "}
                                  {vehicleData.number_of_seat}
                                </CardText>
                              </Col>
                              <Col md={3}>
                                <CardText>
                                  <b>Location of Vehicle:</b>{" "}
                                  {vehicleData.station_of_vehicle}
                                </CardText>
                                <CardText>
                                  <b>Cost per KM:</b> ${vehicleData.cost_per_km}
                                </CardText>
                                <CardText>
                                  <b>Cost per Day:</b> $
                                  {vehicleData.cost_per_day}
                                </CardText>
                                <CardText>
                                  <b>Min Km per Day:</b>{" "}
                                  {vehicleData.distance_per_day} KM
                                </CardText>
                                <CardText>
                                  <b>Availability:</b>{" "}
                                  {vehicleData.availability
                                    ? "Available"
                                    : "Not Available"}
                                </CardText>
                                {selectedAmenities.length > 0 && (
                                  <CardText>
                                    <b>Amenities:</b>{" "}
                                    {selectedAmenities
                                      .map((key) => getAmenityTitle(key))
                                      .filter((amenity) => amenity)
                                      .join(", ")}
                                  </CardText>
                                )}
                              </Col>
                              <Col md={6}>
                                <div
                                  className="custom-carousel-container"
                                  style={{ marginBottom: "25px" }}
                                >
                                  {baseimage.length > 0 ? (
                                    <>
                                      <Carousel
                                        activeIndex={carouselIndex}
                                        onSelect={handleSelectCarousel}
                                        indicators={false}
                                        controls={false}
                                      >
                                        {baseimage.map((item, index) => (
                                          <Carousel.Item key={index}>
                                            {isImage(item.image) ? (
                                              <img
                                                className="d-block w-100"
                                                src={`${base_url.api1}${item.image}`}
                                                alt={`Vehicle ${index + 1}`}
                                                height="311"
                                              />
                                            ) : (
                                              <Player
                                                playsInline
                                                src={`${base_url.api1}${item.image}`}
                                                width="100%"
                                                height="175"
                                                id="vehicleDetail"
                                              />
                                            )}
                                          </Carousel.Item>
                                        ))}
                                      </Carousel>
                                      <div className="custom-carousel-controls">
                                        <span
                                          className="custom-carousel-control prev-control"
                                          onClick={() =>
                                            setCarouselIndex(
                                              carouselIndex === 0
                                                ? baseimage.length - 1
                                                : carouselIndex - 1
                                            )
                                          }
                                        >
                                          &#10094;
                                        </span>
                                        <span
                                          className="custom-carousel-control next-control"
                                          onClick={() =>
                                            setCarouselIndex(
                                              carouselIndex ===
                                                baseimage.length - 1
                                                ? 0
                                                : carouselIndex + 1
                                            )
                                          }
                                        >
                                          &#10095;
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    <img
                                      src="No_image_available.png"
                                      className="d-block w-100"
                                      height="400"
                                      alt="No Image Available"
                                    />
                                  )}
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <label>Note:</label>
                    <textarea
                      className="form-control form-control-sm"
                      {...register("note", {
                        required: false,
                      })}
                      style={{
                        minHeight: "150px",
                        fontSize: "18px",
                      }}
                      id="note"
                    />
                  </div>
                </div>
                <div style={{ padding: "0 20px", marginBottom: "50px" }}>
                  <div>
                    <div
                      style={{
                        float: "right",
                        display: "flex",
                        padding: "5px",
                      }}
                    >
                      <Button
                        type="submit"
                        style={{
                          padding: "10px 40px",
                          marginLeft: "5px",
                          float: "right",
                          borderRadius: "40px",
                        }}
                        color="primary"
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </Col>
          </Row>
          <div className="tourdetails_grid"></div>
        </div>

        <FooterNew />
      </React.Fragment>
    </div>
  );
};

export default BookVehicleForm;
